module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Accelerating Tomorrow","desc1":"Access the markets, accelerate your vision, grow exponentially.","desc2":"We believe in moving people, businesses, and ambitious visions forward."},"ar":{"title":"نمو متسارع لأعمالكم","desc1":"نمكنك من الوصول إلى أسواق رأس المال ونسعى لتحقيق رؤيتك ونمو أعمالك.","desc2":"نعمل لتحقيق الرؤى الطموحة لنمو الأفراد والشركات."}}')
  delete Component.options._Ctor
}
